import { MutationTree } from "vuex";
import * as types from "./types";

const immutableObject = <TParam>(obj: TParam) => {
	return JSON.parse(JSON.stringify(obj)) as TParam;
};

const toggle = (
	state: recipient.state.RecipientState,
	item: recipient.OrgPerson | recipient.Department
) => {
	console.log("mutation", "select", item);
	const selectedUsers = immutableObject(state.orgchart.selectedUsers);
	let szCode: string;
	let szType: "dept" | "user";
	if ("personCode" in item) {
		szType = "user";
		szCode = item.personCode as string;
	} else {
		szType = "dept";
		szCode = item.deptCode as string;
	}

	const found = selectedUsers[szCode];
	if (found) {
		delete selectedUsers[szCode];
	} else {
		selectedUsers[szCode] = item;
	}

	selectedUsers.length = Object.keys(selectedUsers).length - 1;
	state.orgchart.selectedUsers = selectedUsers;
};

export default <MutationTree<recipient.state.RecipientState>>{
	[types.RECIPIENT_LOADING](state, loading: boolean) {
		state.loading = loading;
	},

	[types.RECIPIENT_DEPT_TOGGLE](state, dept: recipient.Department) {
		// select(state, dept, !isSelected(state, dept.deptCode as string))
		toggle(state, dept);
	},

	[types.RECIPIENT_USER_TOGGLE](state, user: recipient.OrgPerson) {
		toggle(state, user);
	},

	[types.RECIPIENT_USER_SELECTALL](state, select: boolean) {
		if (select) {
			throw new Error("NOT_SUPPORTED_EXCEPTION");
		} else {
			state.orgchart.selectedUsers = {
				...Object.create(null),
				length: 0,
			};
		}
	},

	[types.RECIPIENT_COMPANY_CHANGE](state, comCode: string) {
		state.currentCompany = comCode;
	},

	[types.RECIPIENT_USER_LIST](
		state,
		payload: {
			deptCode: string;
      		list: recipient.ItemList<recipient.OrgPerson>;
		}
	) {
		const deptCode = payload.deptCode;

		const findDept = function (parent: Array<recipient.Department>) {
			const result = parent.find((dept) => dept.deptCode === deptCode);
			if (result) {
				return result;
			} else {
				var foundDept = null;
				parent.forEach((dept) => {
					if (dept.children && dept.children.length > 0) {
						var found = findDept(dept.children);
						if (found && found !== undefined) {
							foundDept = found;
						}
					}
				});
				if (foundDept) {
					return foundDept;
				}
			}
		};

		let depts = state.orgchart.dept.items;
		let dept = findDept(depts);
		const users = payload.list;
		users.forEach((x) => (x.selected = false));
		if (dept) {
			dept.users = users;
		} else {
			console.log("ORG_USERS_LIST", "dept not found");
		}
	},

	[types.RECIPIENT_DEPT_LIST](
		state,
		payload: { parentDeptCode: string; children: Array<any> }
	) {
		const parentDeptCode = payload.parentDeptCode;

		function flatToHierarchy(flat: Array<recipient.Department>) {
			var roots: any[] = [];
			var all: any = {};
			var flatArr: any[] = [];
			for (var item of flat) {
				all[item.id] = {
					...item,
					children: null,
					expanded: false,
					selected: false,
				} as recipient.Department;
				flatArr.push(all[item.id]);
			}
			flatArr.forEach(function (item) {
				const parentCode = item.parentDeptCode;
				if (!parentCode) {
					roots.push(item);
				} else if (parentCode in all) {
					var p = all[parentCode] as recipient.Department;
					if (!("children" in p) || !p.children) {
						p.children = [];
					}
					p.children.push(item);
				} else {
					roots.push(item);
				}
			});

			return roots;
		}

		const hierarchy = flatToHierarchy(payload.children);

		const findDept = function (parent: Array<recipient.Department>) {
			const result = parent.find((dept) => dept.deptCode === parentDeptCode);
			if (result) {
				return result;
			} else {
				var foundDept = null;
				parent.forEach((dept) => {
					if (dept.children && dept.children.length > 0) {
						var found = findDept(dept.children);
						if (found && found !== undefined) {
							foundDept = found;
						}
					}
				});
				if (foundDept) {
					return foundDept;
				}
			}
		};

		const dept = findDept(state.orgchart.dept.items);
		
		if (dept) {
			dept.expanded = true;
			dept.children = hierarchy;
		} else {		     
			state.orgchart.dept.items = hierarchy;
		}
	},

	[types.RECIPIENT_VIEW_MODE](state, mode: recipient.ViewMode) {
		state.view = mode;
	},

	[types.RECIPIENT_SEARCH](state, result: recipient.PagedItemList<recipient.OrgPerson>) {
		state.searchResults = result;
	},

	[types.RECIPIENT_SEARCH_KEYWORD](state, keyword: string) {
		state.searchKeyword = keyword;
	},

	[types.RECIPIENT_COMPPANIES_LIST](state, result: recipient.companyInfoList) {
		state.companies = result.companies;
	},
};
